module.exports = __webpack_public_path__ + "img/q-lab-no-color.cf8613c8.svg";